// extracted by mini-css-extract-plugin
export var editButton = "_ls-0";